import { Checkbox, FormControlLabel } from '@material-ui/core';
import './RestrictedCheckbox.scss';

interface RestrictedCheckboxProps {
  isChecked: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => {};
  label?: string;
  isDisabled?: boolean;
}

export default function RestrictedCheckbox({
  isChecked,
  handleChange,
  label = 'Restricted Delivery',
  isDisabled,
}: RestrictedCheckboxProps) {
  const getCheckboxClasses = () => {
    let classes = 'restricted-checkbox';
    if (isChecked) classes += ' restricted-checkbox--checked';
    if (isDisabled) classes += ' restricted-checkbox--disabled';
    return classes;
  };

  return (
    <div className={getCheckboxClasses()}>
      <FormControlLabel
        control={<Checkbox checked={isChecked} onChange={handleChange} disabled={isDisabled} />}
        label={label}
      />
    </div>
  );
}
